import { connect } from 'react-redux';
import { IStoreState } from 'store';
import AddNewUpdateModal from 'pages/whatsnew/add-new-update/add-new-update-modal';
import {
  setAddNewUpdateModalIsOpen,
  setUpdateIds,
  setPostUpdateModalIsOpen,
  saveEditorData,
  setPostUpdateConfirmButtonPressed,
  saveTitle,
  setDeleteUpdateModalIsOpen,
} from 'store/add-new-update/actions';
import { IAddNewUpdateState, IProductReleasesData } from 'store/add-new-update/types';
import { EUpdateModalButton, EUpdateModalSubTitle, EUpdateModalTitle } from 'lib/storage';

export interface IAddNewUpdateModalDispatchProps {
  setAddNewUpdateModalIsOpen: (
    isModalOpen: boolean,
    modalTitle: EUpdateModalTitle,
    updateModalButtonTittle?: EUpdateModalButton,
    updateModalSubTitle?: EUpdateModalSubTitle,
    productReleaseObj?: IProductReleasesData
  ) => void;
  setUpdateIds: (updateIds: string) => void;
  setPostUpdateModalIsOpen: (isPostUpdateModalOpen: boolean) => void;
  saveEditorData: (editorHtml: string) => void;
  setPostUpdateConfirmButtonPressed: (isPostUpdateConfirmButtonPressed: boolean) => void;
  saveTitle: (title: string) => void;
  setDeleteUpdateModalIsOpen: (isDeleteUpdateModalOpen: boolean) => void;
}

export type TAddNewUpdateModalProps = IAddNewUpdateModalDispatchProps & IAddNewUpdateState;

const mapStateToProps = (state: IStoreState): IAddNewUpdateState => ({
  isModalOpen: state.addNewUpdate.isModalOpen,
  updateIds: state.addNewUpdate.updateIds,
  isPostUpdateModalOpen: state.addNewUpdate.isPostUpdateModalOpen,
  editorhtml: state.addNewUpdate.editorhtml,
  isPostUpdateConfirmButtonPressed: state.addNewUpdate.isPostUpdateConfirmButtonPressed,
  title: state.addNewUpdate.title,
  isDeleteUpdateModalOpen: state.addNewUpdate.isDeleteUpdateModalOpen,
  modalTitle: state.addNewUpdate.modalTitle,
  updateModalButtonTittle: state.addNewUpdate.updateModalButtonTittle,
  updateModalSubTitle: state.addNewUpdate.updateModalSubTitle,
  productReleases: state.addNewUpdate.productReleases,
  productReleaseObj: state.addNewUpdate.productReleaseObj,
});

const mapDispatchToProps = {
  setAddNewUpdateModalIsOpen,
  setUpdateIds,
  setDeleteUpdateModalIsOpen,
  setPostUpdateModalIsOpen,
  saveEditorData,
  setPostUpdateConfirmButtonPressed,
  saveTitle,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddNewUpdateModal);
